import { init } from '@web3-onboard/react'
import injectedModule from '@web3-onboard/injected-wallets'
import walletConnectModule from '@web3-onboard/walletconnect'
import { ProviderIdentityFlag } from '@web3-onboard/injected-wallets/dist/types'

console.log('ProviderIdentityFlag', ProviderIdentityFlag)

const injected = injectedModule()
const walletConnect = walletConnectModule()

const initOnboard = init({
  wallets: [injected, walletConnect],
  chains: [
    // {
    //   id: '0x1',
    //   token: 'ETH',
    //   label: 'Ethereum Mainnet',
    //   rpcUrl: endpointblastapi
    // },
    // {
    //   id: '0x3',
    //   token: 'tROP',
    //   label: 'Ethereum Ropsten Testnet',
    //   rpcUrl: 'https://ropsten.infura.io/v3/ababf9851fd845d0a167825f97eeb12b'
    // },
    // {
    //   id: '0x5',
    //   token: 'ETH',
    //   label: 'Ethereum Georli Testnet',
    //   rpcUrl: RPC_URL
    // },
    // {
    //   id: '0x504',
    //   token: 'GLMR',
    //   label: 'MoonBean',
    //   rpcUrl: "https://rpc.api.moonbeam.network"
    // },
    {
      id: '0x250',
      token: 'ASTR',
      label: 'Astar Mainnet',
      rpcUrl: 'https://1rpc.io/astr'
    },
    {
      id: '0x504',
      token: 'GLMR',
      label: 'Moonbeam',
      rpcUrl: 'https://rpc.api.moonbeam.network'
    }
    // {
    //   id: '0x13881',
    //   token: 'MATIC',
    //   label: 'Polygon Mumbai Testnet',
    //   rpcUrl: "https://rpc-mumbai.maticvigil.com"
    // },
    // {
    //   id: '0x89',
    //   token: 'MATIC',
    //   label: 'Matic Mainnet',
    //   rpcUrl: 'https://matic-mainnet.chainstacklabs.com'
    // }
  ],
  appMetadata: {
    name: 'Cult Bears',
    description: 'We are a culture shift',
    recommendedInjectedWallets: [
      { name: 'MetaMask', url: 'https://metamask.io' }
    ],
    agreement: {
      version: '1.0.0',
      termsUrl: 'https://www.blocknative.com/terms-conditions',
      privacyUrl: 'https://www.blocknative.com/privacy-policy'
    },
    gettingStartedGuide: 'https://blocknative.com',
    explore: 'https://blocknative.com'
  }
})

export { initOnboard }
